import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

@Injectable({ providedIn: 'root' })
export class ToastService {
  message = signal('');
  type = signal<ToastType>('info');
  visible = signal(false);

  private timeoutId?: any;

  show(message: string, type: ToastType = 'info', duration = 5000) {
    this.message.set(message);
    this.type.set(type);
    this.visible.set(true);

    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => this.hide(), duration);
  }

  hide() {
    this.visible.set(false);
  }
}
